export const ACTIONS = require("./actions")
export const ENDPOINTS = require("./endpoints")
